import i18n from "../../i18n/i18n"

export enum PaymentType {
    NotSet = 0,
    OnlinePaymentForCitizen = 1,
    Cash = 2,
    GiroForm = 3,
    ElectronicInvoice = 4,
    MobilePay = 5,
    PaidByOtherMeans = 6,
    OnlinePaymentForCompany = 7,
    OnlineBulkPaymentForCompany = 8,
    PartOfBulkPayment = 9,
    GiroFormOtherPayor = 10,
    FreeOfCharge = 11,
    GiroFormBulkPaymentForOtherPayor = 12,
    GiroformOrOnlineBulkPaymentForCompany = 13,
    GiroformOrOnlinePaymentForCompany = 14,
    GiroformPaymentForCompany = 15,
    GiroformBulkPaymentForCompany = 16
}

// tslint:disable-next-line:no-namespace
export namespace PaymentType {
	export function displayName(type: PaymentType) {
		const values: { [index: number]: string } = {
			1: "ENUM_PAYMENTTYPE_ONLINEPAYMENTFORCITIZEN",
			2: "ENUM_PAYMENTTYPE_CASH",
			3: "ENUM_PAYMENTTYPE_GIROFORM",
			4: "ENUM_PAYMENTTYPE_ELECTRONICINVOICE",
			5: "ENUM_PAYMENTTYPE_MOBILEPAY",
			6: "ENUM_PAYMENTTYPE_PAIDBYOTHERMEANS",
			7: "ENUM_PAYMENTTYPE_ONLINEPAYMENTFORCOMPANY",
			8: "ENUM_PAYMENTTYPE_ONLINEBULKPAYMENTFORCOMPANY",
			9: "ENUM_PAYMENTTYPE_PARTOFBULKPAYMENT",
			10: "ENUM_PAYMENTTYPE_GIROFORMOTHERPAYOR",
			11: "ENUM_PAYMENTTYPE_FREEOFCHARGE",
			12: "ENUM_PAYMENTTYPE_GIROFORMBULKPAYMENTFOROTHERPAYOR",
			13: "ENUM_PAYMENTTYPE_GIROFORMORONLINEBULKPAYMENTFORCOMPANY",
			14: "ENUM_PAYMENTTYPE_GIROFORMORONLINEPAYMENTFORCOMPANY",
			15: "ENUM_PAYMENTTYPE_GIROFORMPAYMENTFORCOMPANY",
			16: "ENUM_PAYMENTTYPE_GIROFORMBULKPAYMENTFORCOMPANY"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(PaymentType[type])
		}
	}
}
